/**
 * Данные по значению элемента списка в декларации списка.
 */
export class DeclarationPropertyValueData {
  /**Ключ. */
  public Key: string = "";
  /**
   * Значение.
   */
  public Value: string = "";

  /**
   * Изображение.
   */
  public Image: string = "";

  public attribute: any = null;

  public BankName: string = '';

  /**
   * Конструктор с заполнением.
   * @param key Ключ.
   * @param value Значение.
   * @param image Изображение.
   */
  constructor(key: string, value: string, image: string = "", attribute: any = null, bn: string = '') {
    this.Key = key;
    this.Value = value;
    this.Image = image;
    this.attribute = attribute;
    this.BankName = bn;
  }
}
